import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../themes/Colors";
import FilterButtonSmall from "../filter-button-small/FilterButtonSmall";

const UseFilter = ({ filterName, setScreen }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("ALL");
  const [selectedHover, setSelectedHover] = useState(false);
  return (
    <div
      onClick={open ? null : () => setOpen(true)}
      style={{
        cursor: "pointer",
        height: 56,
        width: open ? 350 : 40,
        // borderStyle: "solid",
        // borderWidth: open ? 1 : 0,
        transition: "all 0.4s",
        marginRight: open ? 3 : 10,
        // borderRadius: 100,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: open ? BlackAndWhite.primary : BlackAndWhite.secondary,
      }}
    >
      {open ? null : (
        <div
          onClick={open ? null : () => setOpen(true)}
          style={{
            marginRight: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? BlackAndWhite.primary
                : BlackAndWhite.primary,
              color: open ? BlackAndWhite.secondary : BlackAndWhite.secondary,
              height: 56,
              width: 120,
              justifyContent: "center",
              alignItems: "center",
              // borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: 14,
            }}
          >
            <div>{selected}</div>
          </div>
        </div>
      )}

      <div
        style={{
          flex: open ? 1 : 0,
          display: "flex",
          overflow: open ? null : "hidden",
        }}
      >
        <div
          style={{
            marginRight: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: open ? 5 : 0,
          }}
        >
          <div
            onMouseOver={() => setSelectedHover("stores")}
            onMouseOut={() => setSelectedHover(null)}
            onClick={() => {
              setSelected("STORES");
              setOpen(false);
              setScreen("stores");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? selected === "STORES"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
                : null,
              color: open
                ? selected === "STORES"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
                : null,
              height: selectedHover === "stores" ? 45 : 35,
              width: selectedHover === "stores" ? 135 : 120,
              justifyContent: "center",
              alignItems: "center",
              // borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: selectedHover === "stores" ? 14 : 12,
              transition: "all 0.3s",
              // WebkitBoxShadow:
              //   selectedHover === "stores"
              //     ? "0px 0px 5px 5px #FFFFFF90"
              //     : "0px 0px 0px 0px #00000040",
            }}
          >
            <div>STORES</div>
          </div>
        </div>
        <div
          style={{
            marginRight: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onMouseOver={() => setSelectedHover("users")}
            onMouseOut={() => setSelectedHover(null)}
            onClick={() => {
              setSelected("ALL");
              setOpen(false);
              setScreen("users");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? selected === "ALL"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
                : null,
              color: open
                ? selected === "ALL"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
                : null,
              height: selectedHover === "users" ? 40 : 35,
              width: selectedHover === "users" ? 135 : 120,
              justifyContent: "center",
              alignItems: "center",
              // borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: selectedHover === "users" ? 14 : 12,
              transition: "all 0.3s",
              // WebkitBoxShadow:
              //   selectedHover === "users"
              //     ? "0px 0px 5px 5px #FFFFFF90"
              //     : "0px 0px 0px 0px #00000040",
            }}
          >
            <div>ALL</div>
          </div>
        </div>
      </div>
      <FilterButtonSmall
        icon1={
          open
            ? require("../../../../../images/material-icons/setupAndMangeWhite.png")
            : require("../../../../../images/material-icons/setupAndMangeBlack.png")
        }
        icon2={
          open
            ? require("../../../../../images/material-icons/setupAndMangeWhite.png")
            : require("../../../../../images/material-icons/setupAndMangeBlack.png")
        }
        label={open ? "CLOSE" : filterName}
        iconHeight={20}
        iconWidth={20}
        fontSize={12}
        fontColor={open ? BlackAndWhite.secondary : BlackAndWhite.primary}
        fontColor1={open ? BlackAndWhite.secondary : BlackAndWhite.primary}
        onClick={() => setOpen(false)}
      />
      {/* <div style={{ width: 10 }} /> */}
    </div>
  );
};

export default UseFilter;
